import { render, staticRenderFns } from "./home-mainlist.vue?vue&type=template&id=77af7e50&lang=pug&"
import script from "./home-mainlist.vue?vue&type=script&lang=js&"
export * from "./home-mainlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports